module.exports = __webpack_public_path__ + "static/media/icons-edit.5c3942b2.svg";